import React from "react";
import "./Final.css"; // Importing the CSS file for styling
function Final() {
  return (
    <div className="final">
      <div className="container">
        <div className="final__container"></div>
        <h2 className="final__header">Что нужно от тебя:</h2>
        <p className="final__text">
          Что бы по скорее закончить: <br /> 1) Определись с бюджетом <br />
          2) Скопируй ссылку на этот сайт <br />
          3) Отправь ее нам
        </p>

        <h2 className="final__header">Что сделаем мы:</h2>
        <p className="final__text">
          1)Подберем букет <br />
          2)Отправим тебе варианты <br />
          3)Предложим открытку <br />
          4)Отправим в лучшем виде
        </p>

        <div className="final__btn-wrapper">
          <a
            href="https://t.me/lovflowmsk"
            className="final__btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            написать нам в telegram
          </a>
          <a
            href="https://wa.me/79269258879"
            className="final__btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            написать нам в whatsapp
          </a>
          <a
            href="https://t.me/lovflowbot/app"
            className="final__btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            выбрать букеты самому
          </a>
        </div>
      </div>
    </div>
  );
}

export default Final;
